<template>
  <div id="tree" class="main-menu-tree" ref="tree" :class="{smallMenu: $store.state.menu.hide}">
    <el-menu default-active="activeMenu" class="el-menu-vertical-demo" :collapse="$store.state.menu.hide">
      <!-- <div style="margin-top: 5px;"></div> -->
      <div v-for="(menuItem, index) in computedMenuList" :key="index">
        <el-menu-item v-if="!menuItem.children || !menuItem.children.length" :index="index + ''">
          <!-- <router-link :to="{name: menuItem.name}">
            <span :class="menuItem.icon" style="padding-right: 8px"></span>
            <span v-show="!$store.state.menu.hide">{{ menuItem.resourceName }}</span>
          </router-link> -->
          <div class="menu-item">
            <i :class="menuItem.resIcon" width="18px" @click="goPage(menuItem)"/>
            <span class="link-a" @click="goPage(menuItem)" target="rightFrame">{{ menuItem.resourceName }}</span>
          </div>
        </el-menu-item>

        <el-submenu v-if="menuItem.children && menuItem.children.length" :index="index + ''">
          <template slot="title" style="padding-left: 10px">
            <i :class="menuItem.resIcon" width="18px" style="margin-right: 16px;" />
            <span>{{ menuItem.resourceName }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item
              v-for="(subMenuItem, subIndex) in menuItem.children"
              :key="subIndex"
              :index="index + '-' + subIndex"
            >
              <!-- <router-link :to="{name: subMenuItem.name}">
                <span>{{ subMenuItem.resourceName }}</span>
              </router-link> -->
              <!-- <a class="link-a" @click="(event) => goPage(event, subMenuItem.resUrl)" target="rightFrame">{{ subMenuItem.resourceName }}</a> -->
              <span :title="subMenuItem.domain + subMenuItem.resUrl" class="link-a" @click="goPage(subMenuItem)" target="rightFrame">{{ subMenuItem.resourceName }}</span>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </div>
    </el-menu>
  </div>
</template>
<script>
import {mapState, mapActions} from 'vuex'
import {menuList} from './../menuList'
import cloneDeep from 'clone-deep';
export default {
  name: 'Tree',
  data() {
    return {
      activeMenu: 0,
      menuList: cloneDeep(menuList),
      
    }
  },
  created() {
    console.log('process.env.NODE_ENV:', process.env.NODE_ENV)
  },
  computed: {
    ...mapState({
      powerRouterList: state => state.powerRouterList,
      newWindowPath: state => state.newWindowPath,
    }),
    computedMenuList: function() {
      var _this = this
      var menuList = cloneDeep(_this.menuList) //所有的菜单项列表
      if (!this.$store.state.hasLogin) {
        return menuList
      }
      // var powerRouterList = this.powerRouterList //具有权限的路由列表
      // var computedMenuList = [] //通过过滤权限，计算得到的菜单项列表
      // menuList.forEach(function(menuItem, index) {
      //   if (menuItem.children && menuItem.children.length) {
      //     //有子菜单的情况
      //     menuItem.children = menuItem.children.filter(function(subMenuItem, subIndex) {
      //       return powerRouterList.includes(subMenuItem.path)
      //     })
      //     if (menuItem.children.length) {
      //       computedMenuList.push(menuItem)
      //     }
      //   } else {
      //     //没有子菜单的情况
      //     if (powerRouterList.includes(menuItem.path)) {
      //       //在权限路由中
      //       computedMenuList.push(menuItem)
      //     }
      //   }
      // })
      return this.powerRouterList.filter(item => item.menuType == 0) // menuType=0 功能菜单
    },
  },
  methods: {
    ...mapActions(['hideMenu', 'showMenu', 'toggleMenu']),
    handleMenu: function() {
      this.toggleMenu()
    },
    getClass(className) {
      return 'fas ' + className
    },
    goPage(urlItem) { // 跳转页面 => 低代码/本项目页面
      if(!urlItem.resUrl) return;
      let _baseUrl = urlItem.domain ? urlItem.domain : document.location.host
      this.$apis.autoAPi.POST_COLLECT_INFO_URL({
        eventType: true,//事件类型
        ipAddress: localStorage.getItem('Ip'),//ip地址
        menuName: urlItem.resourceName,//菜单名称
        menuType: urlItem.resType + '',//菜单类型
        menuUrl: _baseUrl + urlItem.resUrl,// 菜单路由地址
        loginId: this.$store.state.userInfo.loginId
      }).done(res => {})
      if(urlItem.domain) {
        // 跳转乾坤微应用
        // let baseUrl = ''
        // if(urlItem.domain.includes('-logic')) {
        //   baseUrl = '/lcscm'
        //   // this.$router.push({path: '/lcscm' + urlItem.resUrl, query: {label: urlItem.resourceName}})
        // } else if(urlItem.domain.includes('-cost')) {
        //   baseUrl = '/lcscmcost'
        // } else if(urlItem.domain.includes('-user')) {
        //   baseUrl = '/lcscmuser'
        // } else if(urlItem.domain.includes('-data')) {
        //   baseUrl = '/lcscmdata'
        // }
        // this.$router.push({path: baseUrl + urlItem.resUrl, query: {label: urlItem.resourceName}})
        // this.$store.commit('SETLCPAGE', true)

          this.$store.commit('setLcDomain', urlItem.domain)
          this.$router.push({
            name: 'lc-iframe',
            query: {
              page: urlItem.resUrl,
              label: urlItem.resourceName,
              domain: urlItem.domain
            }
          })
          
      } else {
        if(urlItem.resUrl.includes('bi.trendy-global.com')) {
          this.$apis.autoAPi
          .SSO_GET_TOKEN()
          .done(res => {
            if(res.code == 0 && res.data) {
              window.open(`${urlItem.resUrl}?provider=trendygroup&ssoToken=${res.data}`);
            } else {
              this.$message({type: 'warning', message: res.message})
            }
          })
          .fail(err => {
            console.log("fail", err);
          });
        } else {
          if(this.newWindowPath.includes(urlItem.resUrl)) { // 新页面打开
            const url = this.$router.resolve({
              path: urlItem.resUrl
            });
            window.open(url.href, "_blank");
          } else {
            this.$store.commit('SETLCPAGE', false)
            this.$router.push(urlItem.resUrl)
          }
        }
      }
    }
  }
}
</script>
<style lang="less">

#app {
  .tree-container {
    .tree {
      transition: all 0.5s ease;

      span {
        transition: all 0.5s ease;
      }
    }

    #tree .el-menu-item-group {
      background-color: #364150;
    }

    #tree {
      .el-menu-item {
        color: #bac3de !important;
      }

      .el-submenu__title {
        height: 50px;
        padding-left: 10px;
        color: #bac3de !important;

        img {
          color: #bac3de;
          padding-right: 8px;
        }
      }

      .el-submenu__title:hover {
        i {
          color: #ffffff;
        }
      }

      .el-menu-item-group__title {
        display: none;
      }

      .el-submenu__title:hover {
        background-color: #456cf3;
        color: #ffffff;

        .el-icon-location {
          color: #ffffff;
        }
      }
      transition: all 0.5 s ease;
      .el-menu-item:hover {
        color: #ffffff;
      }

      .sollapse-bar {
        height: 30px;
        width: 100%;
        padding-left: 5px;
        margin-top: 15px;
        margin-bottom: 15px;
        display: inline-block;

        .sollapse-icon {
          color: #ffffff;
          width: 30px;
          padding: 2px 2px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          cursor: pointer;
          background-color: #456cf3;
        }

        .sollapse-icon:hover {
          background-color: #456cf3;
        }
      }
    }
    .main-menu-tree {
      width: 200px;
      ul {
        width: 100%;
        border: 0;
      }
      .el-menu-item-group {
        li.el-menu-item {
          padding-left: 45px !important;
        }
      }
    }

    .smallMenu {
      width: 54px;

      .el-icon-arrow-down {
        display: none !important;
      }
    }
  }
}
.menu-item {
  display: flex;
  align-items: center;
}
.link-a {
  display: inline-block;
  width: 100%;
  padding-left: 22px;
}
</style>
